import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Skeleton component for coverage step loading state.
 * Displays 3 category sections (First Party, Third Party, Health Insurance)
 * with header and card placeholders for each section.
 */
export const CoverageStepSkeleton = () => {
  const renderCategorySection = (key: number) => (
    <div key={key} className="space-y-2">
      {/* Category header */}
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          <Skeleton className="h-5 w-48" />
          <Skeleton className="h-4 w-32" />
        </div>
        <Skeleton className="h-9 w-32" />
      </div>

      {/* Coverage cards */}
      <div className="space-y-2">
        {[1, 2].map((cardIndex) => (
          <Card key={cardIndex} className="p-6">
            <div className="space-y-4">
              {/* Row 1: Policy type and carrier */}
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Skeleton className="h-4 w-20" />
                  <Skeleton className="h-10 w-full" />
                </div>
                <div className="space-y-2">
                  <Skeleton className="h-4 w-16" />
                  <Skeleton className="h-10 w-full" />
                </div>
              </div>

              {/* Row 2: Policy number and adjuster */}
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-10 w-full" />
                </div>
                <div className="space-y-2">
                  <Skeleton className="h-4 w-28" />
                  <Skeleton className="h-10 w-full" />
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );

  return (
    <div className="space-y-2 p-2">
      {/* Header skeleton */}
      <div className="space-y-1">
        <Skeleton className="h-5 w-56" />
        <Skeleton className="h-4 w-96" />
      </div>

      {/* Category sections */}
      <div className="space-y-2">
        {/* First Party Coverage */}
        {renderCategorySection(1)}

        {/* Third Party Coverage */}
        {renderCategorySection(2)}

        {/* Health Insurance */}
        {renderCategorySection(3)}
      </div>
    </div>
  );
};
